<template>
  <v-card>
    <v-card-title>Ajuste de Caja</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          label="Monto registrado (sistema)"
          v-model="montoRegistrado"
          :readonly="true"
          type="number"
        />
        <v-text-field
          label="Monto real en caja"
          v-model.number="montoReal"
          :rules="[v => v !== null && v !== '' || 'Ingrese el monto real']"
          type="number"
          required
        />
        <v-text-field
          label="Diferencia"
          :value="diferencia"
          readonly
          type="number"
        />
        <v-textarea
          label="Comentario (opcional)"
          v-model="comentario"
        />
        <v-btn color="primary" @click="registrarAjuste" :disabled="!valid || cargando">
          Registrar Ajuste
        </v-btn>
      </v-form>
      <v-alert v-if="mensaje" :type="exito ? 'success' : 'error'" class="mt-3">{{ mensaje }}</v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import Utiles from '../../Servicios/Utiles';
export default {
  name: 'AjusteCajaForm',
  props: {
    montoRegistrado: {
      type: Number,
      required: true
    },
    usuario: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      montoReal: null,
      comentario: '',
      valid: false,
      cargando: false,
      mensaje: '',
      exito: false
    };
  },
  computed: {
    diferencia() {
      if (this.montoReal === null || this.montoRegistrado === null) return '';
      return Math.round(this.montoReal - this.montoRegistrado);
    }
  },
  methods: {
    async registrarAjuste() {
      if (!this.$refs.form.validate()) return;
      this.cargando = true;
      this.mensaje = '';
      try {
        const formData = new FormData();
        formData.append('usuario', this.usuario);
        formData.append('monto_registrado', this.montoRegistrado);
        formData.append('monto_real', this.montoReal);
        formData.append('diferencia', this.diferencia);
        formData.append('comentario', this.comentario);
        const res = await fetch(Utiles.generarURL('ajustes_caja_registrar.php'), {
          method: 'POST',
          body: formData
        });
        const data = await res.json();
        this.exito = data.exito;
        this.mensaje = data.mensaje;
        if (data.exito) {
          this.montoReal = null;
          this.comentario = '';
          this.$emit('ajuste-registrado');
        }
      } catch (e) {
        this.exito = false;
        this.mensaje = 'Error de conexión.';
      } finally {
        this.cargando = false;
      }
    }
  }
};
</script> 


// WEBPACK FOOTER //
// src/components/Caja/AjusteCajaForm.vue